<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      <section class="text-dc-navy text-sm leading-6 space-y-6">
        <!-- top title -->
        <h1 class="section-heading">
          {{ "TERMS.TITLE" | translate }}
        </h1>
        <div class="fields-container">
          <!-- one section helper -->
          @for (
            section of [
              "PROCESSING_TIME",
              "APPROVAL_REJECTION",
              "DECLARATION",
              "CANCELLATION",
              "SECURITY_AMOUNT",
              "HOLDER_RESP",
              "LOST_GOODS",
              "USE_OF_GOODS",
              "UNDERTAKING",
              "HOLDER_AGREES",
              "RESERVATION",
              "SECURITY_DEPOSIT_REFUND"
            ];
            track section
          ) {
            <!-- heading -->
            <h2 class="text-sm font-semibold">
              {{ "TERMS." + section + ".TITLE" | translate }}
            </h2>
            <!-- bullets -->
            <ul class="list-disc pl-6">
              @for (idx of [1, 2, 3, 4, 5, 6, 7, 8]; track idx) {
                @if (hasTranslation(section, idx)) {
                  <li>
                    {{ "TERMS." + section + ".ITEM" + idx | translate }}
                  </li>
                }
              }
            </ul>
          }
        </div>
      </section>

      <!--Action buttons   ═-->
      <div class="btn-section buttons-group">
        <app-button
          [type]="'button'"
          [label]="'BUTTONS.BACK_TO_APPLICATION' | translate"
          classesName="btn-edge-cut  btn-width-auto"
          (onBtnClick)="back()"
        />
      </div>
    </div>
  </div>
</div>

<!-- <div>
  <app-service-progress
    [serviceName]="'ATA_CARNET.MODIFY_SERVICE' | translate"
    [completePercentage]="formProgress"
  />
</div> -->
